import actions from './actions'
import mutations from './mutations'
import getters from './getters'

export default  {
  namespaced: true,
  state: {
    items:[{
      notifyCode:0,
      count:0,
      color: 'light-blue',
      icon: 'assignment',
      path:'Requests',
    },
      {
        notifyCode:1,
        count:0,
        color: 'red',
        icon: 'question_answer',
        path:'ClientSupport',
      },
    ]

  },
  actions,
  mutations,
  getters
}
